import { render, staticRenderFns } from "./MemberCommunity.vue?vue&type=template&id=552b7d68&scoped=true&"
import script from "./MemberCommunity.vue?vue&type=script&lang=js&"
export * from "./MemberCommunity.vue?vue&type=script&lang=js&"
import style0 from "./MemberCommunity.vue?vue&type=style&index=0&id=552b7d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552b7d68",
  null
  
)

export default component.exports